<div class="showcase-grid">
  <div class="showcase-row" data-showcase-id="cs-markdown">
    <cs-label>cs-markdown</cs-label>
    <cs-markdown textMarkdown="**Bold**, _italic_ and a [link](https://mh-physique.app)." slim></cs-markdown>
  </div>

  <div class="showcase-row" data-showcase-id="cs-store-badges">
    <cs-label>cs-store-badges</cs-label>
    <cs-store-badges androidInstallUrl="https://play.google.com/store/apps/details?id=app.mhphysique.fitness"
      iosInstallUrl="https://apps.apple.com/app/id6767633069"></cs-store-badges>
  </div>

  <div class="showcase-row" data-showcase-id="cs-nutrition-stats-row">
    <cs-label>cs-nutrition-stats-row</cs-label>
    <cs-nutrition-stats-row dailyAvg="2400" mealCalories="600" cutMealCalories="500" bulkMealCalories="700"></cs-nutrition-stats-row>
  </div>

  <div class="showcase-row" data-showcase-id="cs-nutrition-plan-card">
    <cs-label>cs-nutrition-plan-card</cs-label>
    <cs-nutrition-plan-card [nutrition]="nutritionPlan" [trainingGoal]="TrainingGoal.MuscleGrowth"></cs-nutrition-plan-card>
  </div>

  <div class="showcase-row" data-showcase-id="cs-muscle-volume">
    <cs-label>cs-muscle-volume</cs-label>
    <cs-muscle-volume [upperBodyMuscles]="upperBodyVolume" [lowerBodyMuscles]="lowerBodyVolume"></cs-muscle-volume>
  </div>

  <div class="showcase-row" data-showcase-id="cs-food-card">
    <cs-label>cs-food-card</cs-label>
    <cs-food-card [food]="sampleFood" [description]="'1 medium (118 g)' | untranslated" imageUrl=""
      [showMenuButton]="true"></cs-food-card>
  </div>

  <div class="showcase-row" data-showcase-id="cs-recent-meals-empty-state">
    <cs-label>cs-recent-meals-empty-state</cs-label>
    <cs-recent-meals-empty-state [recentMeals]="recentMeals" currentMealName="Lunch"></cs-recent-meals-empty-state>
  </div>

  <div class="showcase-row" data-showcase-id="cs-log-detail-content">
    <cs-label>cs-log-detail-content</cs-label>
    <cs-log-detail-content [sets]="logDetailSets"></cs-log-detail-content>
  </div>

  <div class="showcase-row" data-showcase-id="cs-workout-overview">
    <cs-label>cs-workout-overview</cs-label>
    <cs-workout-overview [workouts]="workoutsOverview" [(selectedWorkout)]="selectedWorkout"></cs-workout-overview>
  </div>

  <div class="showcase-row" data-showcase-id="cs-exercise-button-bar">
    <cs-label>cs-exercise-button-bar</cs-label>
    <cs-exercise-button-bar [showAddNote]="true"></cs-exercise-button-bar>
  </div>
</div>
